// extracted by mini-css-extract-plugin
export default {"container":"styles_container__vv36E","footer":"styles_footer__jtk20"};